import { render, staticRenderFns } from "./carPart.vue?vue&type=template&id=39de01a3&scoped=true"
import script from "./carPart.vue?vue&type=script&lang=js"
export * from "./carPart.vue?vue&type=script&lang=js"
import style0 from "./carPart.vue?vue&type=style&index=0&id=39de01a3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39de01a3",
  null
  
)

export default component.exports